import { render } from "./index.vue?vue&type=template&id=609e084d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=609e084d&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/common/components/BaseDelete/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "609e084d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('609e084d', __exports__)) {
    api.reload('609e084d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=609e084d", () => {
    api.rerender('609e084d', render)
  })

}


export default __exports__